import { Select } from "antd";
import { useEffect, useMemo, useState } from "react";

// Reuse styles from AllManualActions
import "../AllManualActions/stylesAllManualActions.css";
import DataTable from "../../shared/dashboards/DataTable/DataTable";
import styles from "./AgentPerformanceView.module.css";
import { AppStrings } from "../../../utils/constants/AppStrings";

/** Fake role values for agent performance (until API provides roles). */
export const AGENT_PERFORMANCE_ROLE_OPTIONS = [
  { value: "admin", label: "Admin" },
  { value: "customer_support", label: "Customer Support" },
  { value: "compliance_agent", label: "Compliance Agent" },
];

function AgentPerformanceView({
  columns,
  handleTableChange,
  filteredData,
  roleOptions,
  selectedRoles: selectedRolesProp,
  onRoleChange,
  pagination: paginationProp,
  isLoading = false,
  scrollX = 1800,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, _setPageSize] = useState(20);
  const [internalSelectedRoles, setInternalSelectedRoles] = useState([]);

  const isControlled =
    selectedRolesProp !== undefined && onRoleChange !== undefined;
  const selectedRoles = isControlled
    ? selectedRolesProp
    : internalSelectedRoles;
  const handleRoleChange = isControlled
    ? onRoleChange
    : setInternalSelectedRoles;
  const options = roleOptions;

  // Single-select: get a single value and convert the onChange result into an array
  const selectValue = selectedRoles[0];
  const handleSingleRoleChange = (val) => {
    handleRoleChange(val !== undefined ? [val] : []);
  };

  const displayData = useMemo(() => {
    const base = filteredData ?? [];
    // In controlled mode the parent already sends server-filtered data — no client-side filtering needed
    if (isControlled) return base;
    if (!selectedRoles.length) return base;
    return base.filter((row) => row.role && selectedRoles.includes(row.role));
  }, [filteredData, selectedRoles, isControlled]);

  const pagedRows = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return displayData.slice(start, start + pageSize);
  }, [displayData, currentPage, pageSize]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedRoles]);

  return (
    <div className={styles.agentPerformanceViewContainer}>
      <div className={styles.agentPerformanceViewHeader}>
        <div className={styles.agentPerformanceViewSelector}>
          <span className={styles.agentPerformanceViewSelectorTitle}>
            {AppStrings.ROLE}
          </span>
          {/* Endpoint(s) only support 1 role_id at the moment */}
          <Select
            allowClear
            placeholder={AppStrings.NOT_SELECTED}
            className={styles.roleSelect}
            onChange={handleSingleRoleChange}
            value={selectValue}
            options={options}
          />
        </div>
      </div>
      <div className={styles.agentPerformanceViewTableContainer}>
        <DataTable
          columns={columns}
          dataSource={isControlled ? displayData : pagedRows}
          pagination={isControlled && paginationProp ? paginationProp : true}
          onChange={handleTableChange}
          rowKey="key"
          scroll={{ x: scrollX, y: 550 }}
          loading={isLoading}
        />
      </div>
    </div>
  );
}

export default AgentPerformanceView;
